import { defineStyleConfig } from '@chakra-ui/react';

export const Divider = defineStyleConfig({
  baseStyle: {
    opacity: 1,
  },
});
